class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter((li) => !r.some((ri) => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach((oi) => {
      const ni = newCart.items.find((i) => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0 ? result.added.push(item) : result.removed.push(item);
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent('cart_changed', { detail: { changes, newCart } });
    this.storeCart(newCart);
    window.dispatchEvent(event);
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ['resource'] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();

// USAGE
// window.addEventListener('cart_changed', (event) => {
// console.log('==> Cart changed! <==');
// console.log(e.detail);
// console.log(e.detail.changes);
// console.log(e.detail.newCart);
// });

// CART MAP
// {
//     "attributes": {},
//     "cart_level_discount_applications": [],
//     "checkout_charge_amount": "380.25",
//     "currency": {},
//     "discount_applications": [],
//     "discounts": [],
//     "duties_included": false,
//     "empty?": false,
//     "item_count": 2,
//     "items": [],
//     "items_subtotal_price": "422.49",
//     "note": "Hello this is a note",
//     "original_total_price": "424.99",
//     "requires_shipping": true,
//     "taxes_included": false,
//     "total_discount": "44.74",
//     "total_price": "380.25",
//     "total_weight": 0
//   }
